<template>
  <div class="aiMatch">
  	<van-tabs v-model="activeName" @click="changeTab" sticky>
		  <van-tab name="match">
		  	<div slot="title">
		  		<span class="title">
		  			AI人岗匹配
		  			<span class="dot" v-if="count.aiTalentUnreadTotal"></span>
		  		</span>
		  	</div>
		  	<ai-search v-if="activeName=='match'"></ai-search>
		  	<match-list></match-list>
		  </van-tab>
		  <van-tab name="recommend">
		  	<div slot="title">
		  		<span class="title">
			  		AI复推
			  		<span class="dot" v-if="count.aiCandidateUnreadTotal"></span>
			  	</span>
		  	</div>
		  	<recommend-search v-if="activeName=='recommend'"></recommend-search>
		  	<recommend-list></recommend-list>
		  </van-tab>
		</van-tabs>
  </div>
</template>

<script>

import AiSearch from '@/components/aiMatch/aiSearch'
import RecommendSearch from '@/components/aiMatch/recommendSearch'
import MatchList from '@/components/aiMatch/matchList'
import RecommendList from '@/components/aiMatch/recommendList'
import {getAiRecommendCountNew} from '@/api/aiMatch'
import { mapState } from 'vuex' ;

export default {
  name: "aiMatch-module",
  components: {
  	AiSearch,
  	RecommendSearch,
  	MatchList,
  	RecommendList
  },
  data(){
  	return {
  		activeName: this.$route.query.type || 'match',
  		hasMatch: false,
  		hasRecommend: false,
  		isChange: false,
  		count: {}
  	}
  },
  computed: {
  	...mapState({
      getUserInfo: state => state.comp.userInfo || {}
    })
  },
  methods: {
  	changeTab(name){
  		this.isChange = !this.isChange;
  		this.$router.replace({name: this.$route.name, query: {type: name}});
  	},
  	init(){

  		let userInfo = this.getUserInfo || {};
  		let params = {
  			status: 1,
  			hunterIds: userInfo.userId
  		};
  		getAiRecommendCountNew(params).then(res=>{
  			this.count = res.data ? res.data : {};
  		})
  	}
  },
  mounted(){
  },
  created() {
	  this.init();
	  this.$store.commit('comp/WX_SHARE',{
		title:'猎上AI - AI做单、更易成单、速来推人',
		desc:'重新定义人才服务'
	});
  }
};
</script>

<style scoped lang="scss">
	.aiMatch{
		.van-tab{
			span.title{
				position: relative;
				display: inline-block;
				font-size: 16px;
				.dot{
					width: 8px;
			    min-width: 0;
			    height: 8px;
			    background-color: #ee0a24;
			    border-radius: 100%;
			    position: absolute;
			    top: 14px;
			    right: -6px;
			    z-index: 99;
				}
			}
		}
	}
</style>
